import React from 'react';

const BurgerButton: React.FC<{ isOpen: boolean, onClick: () => void }> = ({ isOpen, onClick }) => (
	<label className="menu-burger" onClick={onClick}>
		<span className={`menu-burger__span ${isOpen ? 'menu-burger__span_open' : ''}`} />
	</label>
);

export default BurgerButton;